import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";
import { ISsoStatus } from "./SsoConfiguration";

export const useStyles = makeStyles<Theme>(() => ({
  statusBadge: {
    padding: "3px 7px 2px",
    marginTop: "4px",
    fontSize: "11px",
    fontWeight: "bold",
    borderRadius: "5px",
    display: "inline-flex",
  },
  [ISsoStatus.ACTIVE]: {
    backgroundColor: "#1eac8a",
    color: "white",
  },
  [ISsoStatus.INACTIVE]: {
    backgroundColor: "#f7494a",
    color: "white",
  },
  [ISsoStatus.PENDING]: {
    backgroundColor: "#e9bf25",
  },
}));
